import { createDataGridFilter } from '../create-data-grid-filter';
import {
  createRangeDateFilterModel,
  RangeDateFilterModel,
  rangeDateFilterModelName,
  RangeDateFilterParams,
} from './core';
import { RangeDateFilterComponent } from './range-date-filter.component';

export const RangeDateFilterDataGrid = createDataGridFilter<
  RangeDateFilterModel,
  RangeDateFilterParams
>((params) => ({
  modelName: rangeDateFilterModelName,
  modelFactory: createRangeDateFilterModel,
  component: (props) => (
    <RangeDateFilterComponent {...props} filterParams={params} />
  ),
}));

export type RangeDateFilterDataGridComponent = ReturnType<
  typeof RangeDateFilterDataGrid
>;
